import React from 'react';
import Container from '../../v2/container';
import ShipmentDetailsContainer from './ShipmentDetailsContainer';

const ShipmentDetailsFullPage = (props) => {
  return (
    <Container className="py-6" useMaxWidth={false}>
      <ShipmentDetailsContainer {...props} />
    </Container>
  );
};
export default ShipmentDetailsFullPage;
